// Controls
import { OneDrivePickerDialog } from "../oneDrivePicker/OneDrivePickerDialog";
// Styles
import { getPlannerAppDialogContentStyles, getPlannerAppDialogStyles } from "../../../../local/utilities/BaseDialog.styles";
import { getCustomOneDrivePickerStyles } from "./OneDrivePickerForAttachments.styles";
import { openFolderProps, wordLogoIconProps, pdfIconProps, excelLogoIconProps, powerPointLogoIconProps, oneNoteLogoIconProps, projectLogoIconProps, visioLogoIconProps, imageIconProps, folderProps, documentProps } from "../../../icons/icons.styles";
// Utilities
import * as React from "react";
import { Strings } from "@ms/uno-resources/lib/local/CultureUtilities";
import { useTheme } from "@fluentui/react";
/** SVG icon overrides */ const OneDrivePickerIconsOverrides = {
    word: wordLogoIconProps,
    excel: excelLogoIconProps,
    powerpoint: powerPointLogoIconProps,
    onenote: oneNoteLogoIconProps,
    project: projectLogoIconProps,
    visio: visioLogoIconProps,
    photo: imageIconProps,
    pdf: pdfIconProps,
    folder: folderProps,
    openFolder: openFolderProps,
    document: documentProps
};
/**
 * Default strings props to be used with OneDrivePickerForAttachments
 */ export function getOneDrivePickerStrings() {
    return {
        documents: Strings.OneDrivePickerForAttachments_Documents,
        existingFileError: Strings.OneDrivePickerForAttachments_ExistingFileError,
        save: Strings.OneDrivePickerForAttachments_Save,
        cancel: Strings.OneDrivePickerForAttachments_Cancel,
        fileName: Strings.OneDrivePickerForAttachments_FileName,
        image: Strings.OneDrivePickerForAttachments_Image,
        sharePointFileListLabel: Strings.OneDrivePickerForAttachments_SharePointFileListLabel,
        columnHeaderAriaLabel: Strings.OneDrivePickerForAttachments_ColumnHeaderAriaLabel,
        columnFileType: Strings.OneDrivePickerForAttachments_ColumnFileType,
        columnName: Strings.OneDrivePickerForAttachments_ColumnName,
        columnModifiedDate: Strings.OneDrivePickerForAttachments_ColumnModifiedDate,
        emptyFolder: Strings.OneDrivePickerForAttachments_EmptyFolder,
        columnSortAscendingAriaLabel: Strings.OneDrivePickerForAttachments_SortAscendingLabel,
        columnSortDescendingAriaLabel: Strings.OneDrivePickerForAttachments_SortDescendingLabel,
        loadingFolderAriaLabel: Strings.OneDrivePickerForAttachments_LoadingFolderAriaLabel,
        loadingErrorTitle: Strings.OneDrivePickerForAttachments_FileLoadErrorTitle,
        retry: Strings.OneDrivePickerForAttachments_Retry,
        loadingErrorMessage: Strings.OneDrivePickerForAttachments_FileLoadErrorGenericMessage
    };
}
/**
 * Render One drive picker
 * @param props property of one drive picker for attachments
 */ export function OneDrivePickerForAttachments(props) {
    const theme = useTheme();
    const { oneDrivePickerProps, ...dialogProps } = props;
    const dialogStyles = getPlannerAppDialogStyles(theme);
    const dialogContentStyles = getPlannerAppDialogContentStyles(theme);
    const customOneDrivePickerStyles = getCustomOneDrivePickerStyles(theme);
    return /*#__PURE__*/ React.createElement(OneDrivePickerDialog, {
        styles: dialogStyles,
        dialogContentStyles: dialogContentStyles,
        ...dialogProps,
        oneDrivePickerProps: {
            ...oneDrivePickerProps,
            styles: customOneDrivePickerStyles,
            icons: OneDrivePickerIconsOverrides
        }
    });
}
